import ConnectIcon from '@/shared/assets/icons/connectIcon.svg?react'
import { Button } from '@headlessui/react'

type Props = {
  onClick: () => void
}

export const ConnectionButton = ({ onClick }: Props) => {
  return (
    <Button
      onClick={onClick}
      className="flex gap-2 rounded-lg py-[3px] px-[16px] bg-light-purple dark:bg-dark-purple cursor-pointer"
    >
      <ConnectIcon className="text-primary" />
      <span className="text-text-main dark:text-white font-klein font-medium text-sm">
        Перепривязать
      </span>
    </Button>
  )
}
